import { useForm } from "react-hook-form";
import Modal from "../../layouts/Modal";
import { NumberInput } from "../shared/Inputs/NumberInput";
import ExporterSelect from "./ExporterSelect";
import useExportOffers from "../../data/useExportOffers";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import { ExportSource, ExportType } from "../../models/ExportOffer";
import { useEffect } from "react";

export interface AssignExporterForm {
  price: number;
  userId: string;

  source: ExportSource;
  type: ExportType;

  vehicleId: string;

  isAccepted?: boolean;
}

export default function AssignExporterModal({initialValues, setInitialValues}: {initialValues: AssignExporterForm | null, setInitialValues: any}) {
  const { create } = useExportOffers();

  const { register, setValue, watch, handleSubmit, reset } = useForm<AssignExporterForm>({
    defaultValues: initialValues ?? {}
  });

  useEffect(() => {
    reset(initialValues ?? {});
  }, [initialValues, reset]);

  const onSubmit = (data: AssignExporterForm) => {
    create.mutate(data, {
      onSuccess: () => {
        setInitialValues(null);
        reset();
      } 
    });
  }

  return (
    <Modal open={!!initialValues} width="max-w-xl" setOpen={() => setInitialValues(null)} >
      <h2 className="text-xl font-semibold pb-2 mb-2 border-b ">Assign Exporter to {ExportType[initialValues?.type ?? 0]}</h2>
      <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="flex">
          <NumberInput
            label="Price"
            register={register}
            registerName={"price"}
            classes="w-full"
          />
        </div>

        <ExporterSelect register={register} setValue={setValue} watch={watch} />

        <input type="hidden" {...register("source")} value={initialValues?.source} />
        <input type="hidden" {...register("type")} value={initialValues?.type} />
        <input type="hidden" {...register("vehicleId")} value={initialValues?.vehicleId} />

        <ButtonInput  
          isSubmit={true}
          label="Assign Exporter"
          onClick={() => { }}
          classes={"mt-6 sm:mt-0 sm:col-span-2" }
        />
      </form>
    </Modal>
  )
} 